import React, { useEffect, useState } from "react";

const Hero: React.FC = () => {
  const [typedText, setTypedText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const fullText = "Pulih Bersama , Bangkit Berdaya";

  useEffect(() => {
    let t: NodeJS.Timeout;

    if (charIndex <= fullText.length) {
      t = setTimeout(() => {
        setTypedText(fullText.slice(0, charIndex));
        setCharIndex((p) => p + 1);
      }, 80);
    } else {
      t = setTimeout(() => setCharIndex(0), 2000);
    }

    return () => clearTimeout(t);
  }, [charIndex]);

  return (
    <section className="relative w-full h-[105vh] max-sm:h-[90vh] max-lg:h-[80vh] text-white overflow-hidden -mt-24 rounded-es-[6rem] rounded-ee-[6rem] max-sm:rounded-es-[2rem] max-sm:rounded-ee-[2rem]">
      {/* BG */}
      <img src="/images/bgutama.jpg" alt="bg" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/75" />

      {/* CONTENT */}
      <div className="relative z-10 flex flex-col justify-center h-full px-4 lg:px-20 text-center ">
        <div className="flex justify-center">
          <img src="/images/logo_peduli2.png" className="w-28 h-28 drop-shadow-[0_10px_30px_rgba(0,0,0,0.45)]" alt="" />
        </div>
        <h1 className="text-[30px] md:text-5xl xl:text-6xl font-bold text-red-500">
          BANGKIT <span className="text-white">BERDAYA</span>
        </h1>

        {/* <h3 className="font-bilbo text-[45px] md:text-6xl xl:text-7xl -mt-9  lg:-mt-4 xl:-mt-9">
          <span className="text-red-500">Peduli</span> Sesama
        </h3> */}

        <p className="text-gray-300 text-sm md:text-2xl font-semibold h-[32px] ">
          {typedText}
          <span className="animate-pulse">|</span>
        </p>

        <div className="flex justify-center mb-2 mt-2 md:mt-4 md:mb-0 ">
          <img src="/images/logo/logo_pm.png" alt="" className="w-12 h-14 " />
        </div>

        {/* SUPPORT & PARTNER */}
        <div className="w-full max-w-7xl mx-auto mt-4 mb-6 flex  gap-8 max-md:gap-10 justify-center">
          {/* KIRI — Didukung Oleh */}

          {/* <div className="space-y-3 text-center">
            <p className="font-medium">Didukung Oleh :</p>

            <div className="flex flex-wrap justify-center items-center gap-4">
              <img src="/images/logo/mensos.png" alt="" className="w-12 h-12" />
              <img src="/images/logo/migran.png" alt="" className="w-12 h-12" />
              <img src="/images/logo/desa.png" alt="" className="w-12 h-12" />
              <img src="/images/logo/menkop.png" alt="" className="w-12 h-12" />
              <img src="/images/logo/umkm.png" alt="" className="w-12 h-12" />
              <img src="/images/logo/ekraf.png" alt="" className="w-12 h-12" />
            </div>
          </div> */}

          {/* KANAN — Mitra Kolaborasi */}
          <div className="space-y-3 text-center w-full">
            <p className="font-medium">Kolaborasi Multipihak :</p>

            <div className="flex flex-wrap justify-center items-center gap-3">
              {/* <img src="/images/logo/logo_pm.png" alt="" className="w-10 h-12 hidden md:block " /> */}
              <img src="/images/logo/logo_kemenag.png" alt="" className="w-10 h-10  " />
              <img src="/images/logo/logo_kemenaker.png" alt="" className="w-10 h-10" />
              <img src="/images/logo/logo_mui.png" alt="" className="w-10 h-10 " />
              <img src="/images/logo/logo_brilian.png" alt="" className="w-10 h-10 " />
              <img src="/images/logo/inh.png" alt="" className="w-10 h-10 " />
              <img src="/images/logo/rumahzakat.png" alt="" className="w-10 h-10 " />
              <img src="/images/logo/budha.png" alt="" className="w-12 h-10" />
              <img src="/images/logo/logo_bpkh.png" alt="" className="w-16 h-10 " />
              <img src="/images/logo/logo_foz.png" alt="" className="w-14 h-10 " />
              <img src="/images/logo/ruangamal.png" alt="" className="w-20 h-10 " />
              <img src="/images/logo/filantropi.png" alt="" className="w-16 h-10 " />
              <img src="/images/logo/metro.png" alt="" className="w-20 h-10 " />
              <img src="/images/logo/bk.png" alt="" className="w-8 h-10 " />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
